/* import React from 'react';
import { Link } from 'react-router-dom';
import Spacing from '../Spacing';
import { Icon } from '@iconify/react';

export default function CommentsWidget({ title }) {
  return (
    <div id="comments" className="comments-area">
      <h2 className="comments-title cs-semi_bold cs_fs_24 cs_semibold mb-0">
        {title}
      </h2>
      <Spacing md="45" />
      <ol className="comment-list">
        <li className="comment">
          <div className="comment-body">
            <div className="comment-author vcard">
              <img
                className="avatar"
                src="/images/blog/avatar_1.png"
                alt="Author"
              />
              <Link to="/" className="url">
                George Steven
              </Link>
            </div>
            <div className="comment-meta">
              <Icon icon="fa6-solid:clock" />
              <Link to="/">Jan 24, 2023 </Link>
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation.
            </p>
            <div className="reply">
              <Link className="comment-reply-link" to="/">
                Reply
              </Link>
            </div>
          </div>
          <ol className="children">
            <li className="comment">
              <div className="comment-body">
                <div className="comment-author vcard">
                  <img
                    className="avatar"
                    src="/images/blog/avatar_2.png"
                    alt="Author"
                  />
                  <Link to="/" className="url">
                    Sarah Taylor
                  </Link>
                </div>
                <div className="comment-meta">
                  <Icon icon="fa6-solid:clock" />
                  <Link to="/">Jan 24, 2022 at 9:59 am </Link>
                </div>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud.
                </p>
                <div className="reply">
                  <Link className="comment-reply-link" to="/">
                    Reply
                  </Link>
                </div>
              </div>
            </li>
          </ol>
        </li>
        <li className="comment">
          <div className="comment-body">
            <div className="comment-author vcard">
              <img
                className="avatar"
                src="/images/blog/avatar_3.png"
                alt="Author"
              />
              <Link to="/" className="url">
                Jhon Doe
              </Link>
            </div>
            <div className="comment-meta">
              <Icon icon="fa6-solid:clock" />
              <Link to="/">Jan 24, 2022 at 9:59 am </Link>
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation. Duis aute irure
              dolor in reprehenderit in voluptate velit esse cillum dolore
            </p>
            <div className="reply">
              <Link className="comment-reply-link" to="/">
                Reply
              </Link>
            </div>
          </div>
        </li>
      </ol>
    </div>
  );
}
 */
import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import Spacing from '../Spacing';
import { Icon } from '@iconify/react';

export default function CommentsWidget({ title, postId }) {
  const [comments, setComments] = useState([]);

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const commentsRef = query(
          collection(db, 'blogs', postId, 'comments'),
          orderBy('timestamp', 'desc') // Optional: sort by newest first
        );
        const querySnapshot = await getDocs(commentsRef);
        const commentList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setComments(commentList);
      } catch (error) {
        console.error('Failed to load comments:', error);
      }
    };

    if (postId) fetchComments();
  }, [postId]);

  return (
    <div id="comments" className="comments-area">
      <h2 className="comments-title cs-semi_bold cs_fs_24 cs_semibold mb-0">
        {title}
      </h2>
      <Spacing md="45" />
      {comments.length === 0 ? (
        <p>No comments yet.</p>
      ) : (
        <ol className="comment-list">
          {comments.map((comment) => (
            <li className="comment" key={comment.id}>
              <div className="comment-body">
                <div className="comment-author vcard">
                  <img
                    className="avatar"
                    src="/images/blog/avatar_1.png"
                    alt={comment.name || 'User'}
                  />
                  <span className="url">{comment.name || 'Anonymous'}</span>
                </div>
                <div className="comment-meta">
                  <Icon icon="fa6-solid:clock" />
                  <span className="ms-1">
                    {comment.timestamp?.toDate
                      ? comment.timestamp.toDate().toLocaleString()
                      : comment.timestamp || 'Unknown date'}
                  </span>
                </div>
                <p>{comment.message}</p>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
